"use client";

import { useState } from "react";
import FooterSection from "@/components/common/Footer";
import FloatingNav from "@/components/common/Header";

export default function GlobalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  return (
    <>
      <div className="relative z-10">{children}</div>
      <FooterSection setIsVisible={setIsFooterVisible} />
      <FloatingNav visible={!isFooterVisible} />
    </>
  );
}
